export default "__VITE_ASSET__CmCFLoL2__"